module.exports = __webpack_public_path__ + "static/media/logo_tab.adbd4996.svg";